import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { NotificationsService } from 'src/app/services/notifications.service';
import { UserService } from 'src/app/services/user.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  notifications: any;
  oficial!: any;
  verified!: any;
  profileMe!: any;

  @Output() emitSave: EventEmitter<boolean> = new EventEmitter<boolean>();

  originalNotifications: any;
  hasChanges: boolean = false;

  constructor(
    private notificationsService: NotificationsService,
    private users: UserService,
    private auth: AuthenticationService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.notificationsService.getNotificationsUser().subscribe({
      next: (data) => {
        this.notifications = data;
      }
    })
    // Hacemos una copia profunda del objeto original
    this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
  }

  getData() {
    this.profileMe = this.auth.getProfile();
    this.oficial = this.profileMe?.site;
    this.verified = this.profileMe?.sms;
  }
  saveNotifications() {
    this.emitSave.emit(this.notifications);
    // Actualizamos el estado original
    this.originalNotifications = JSON.parse(JSON.stringify(this.notifications));
    this.hasChanges = false;
  }

  goBack() {
    this.location.back();
  }

  onToggleChange() {
    this.hasChanges = JSON.stringify(this.notifications) !== JSON.stringify(this.originalNotifications);
  }
}
